if (!customElements.get('product-form')) {

  customElements.define(

    'product-form',

    class ProductForm extends HTMLElement {

      constructor() {

        super();

        this.form = this.querySelector('form');

        this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.cartLimitError = false;
        this.cartLimitCheckPending = false;

      }

      connectedCallback() {
      this.quantityChangeHandler = (event) => {
        if (event.target.matches('.quantity__input')) this.validateStockQuantity();
        if (event.type === 'change' && event.target.matches('.kavedan-care__checkbox')) {
          this.updateCareSelection(event.target);
        }
      };
      this.closest('product-info')?.addEventListener('change', this.quantityChangeHandler);
      this.closest('product-info')?.addEventListener('input', this.quantityChangeHandler);
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // Sepet değiştikçe hem stok miktarını hem butonun görünümünü güncelle.
        if (event.source !== 'product-form') this.recheckCartLimitError();
      });
      this.pageShowHandler = () => this.recheckCartLimitError();
      window.addEventListener('pageshow', this.pageShowHandler);
    }

    disconnectedCallback() {
      this.cartUpdateUnsubscriber?.();
      window.removeEventListener('pageshow', this.pageShowHandler);
      this.closest('product-info')?.removeEventListener('change', this.quantityChangeHandler);
      this.closest('product-info')?.removeEventListener('input', this.quantityChangeHandler);
    }

    async updateCareSelection(checkbox) {
      if (this.careAddPending) return;
      const mainVariantId = String(this.variantIdInput.value);
      const careVariantId = String(checkbox.dataset.careVariantId || '');
      if (!/^\d+$/.test(careVariantId) || mainVariantId === careVariantId) return;

      const addCare = checkbox.checked;
      this.careAddPending = true;
      checkbox.disabled = true;
      try {
        const cartResponse = await fetch(`${routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!cartResponse.ok) throw new Error('Sepet kontrol edilemedi.');
        const cart = await cartResponse.json();
        const mainAlreadyInCart = cart.items.some(item => String(item.variant_id) === mainVariantId);
        const careLines = cart.items.filter(item => String(item.variant_id) === careVariantId);

        // Ana ürün ilk kez alınacaksa birlikte ekleme hâlâ Sepete Ekle ile yapılır.
        if (addCare && !mainAlreadyInCart) {
          this.careSelectionSeparate = false;
          return;
        }

        this.careSelectionSeparate = addCare && mainAlreadyInCart;

        if (addCare && careLines.length > 0) return;
        if (!addCare && careLines.length === 0) return;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        let payload;
        let url;
        if (addCare) {
          payload = { items: [{ id: Number(careVariantId), quantity: 1 }] };
          url = routes.cart_add_url;
        } else {
          // Aynı krem farklı satırlarda olsa bile anahtar kapatıldığında tümünü kaldır.
          payload = { updates: Object.fromEntries(careLines.map(item => [item.key, 0])) };
          url = routes.cart_update_url;
        }
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map(section => section.id);
          payload.sections_url = window.location.pathname;
        }
        config.body = JSON.stringify(payload);
        const response = await fetch(url, config);
        const data = await response.json();
        if (!response.ok || data.status || data.errors) {
          throw new Error(data.description || data.message || 'Bakım kremi güncellenemedi.');
        }

        if (this.cart) {
          // Craft çekmecesi hem ekleme hem çıkarma sonucunda güncel HTML'yi kullanır.
          if (addCare && Array.isArray(data.items)) data.id = Number(careVariantId);
          this.cart.renderContents(data);
        } else {
          window.location.href = routes.cart_url;
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: careVariantId,
          cartData: data
        });
        this.handleErrorMessage();
      } catch (error) {
        checkbox.checked = !addCare;
        this.careSelectionSeparate = false;
        this.handleErrorMessage(error.message || 'Bakım kremi güncellenemedi.');
      } finally {
        checkbox.disabled = false;
        this.careAddPending = false;
      }
    }

    validateStockQuantity(showError = true) {
      const input = this.closest('product-info')?.querySelector('.quantity__input');
      if (!input || this.variantIdInput.disabled) return true;
      const limit = input.dataset.stockLimit;
      // Sepet doluluğu, gerçekten stokta olan ürünü pasif görünüme sokmasın.
      // Stok 0 veya devam-satış dışındaki satışa kapalı varyantları zorla açma.
      const isStocked = limit !== undefined && Number(limit) > 0;
      if (isStocked && !this.submitButton.classList.contains('loading')) {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.classList.remove('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
      if (this.submitButton.disabled) return true;
      const quantity = Number(input.value);
      const max = limit === undefined ? null : Math.max(0, Number(limit) - Number(input.dataset.cartQuantity || 0));
      const invalid = max !== null && Number.isFinite(quantity) && quantity > max;
      if (invalid && showError) {
        this.submitButton.removeAttribute('aria-disabled');
        this.handleErrorMessage(max === 0
          ? 'Bu üründen stokta bulunan tüm adetleri sepetinize eklediniz.'
          : `Bu üründen en fazla ${max} adet daha ekleyebilirsiniz.`);
      } else {
        this.cartLimitError = false;
        this.error = false;
        this.handleErrorMessage();
        const soldOut = this.submitButton.querySelector('.sold-out-message');
        if (soldOut) soldOut.classList.add('hidden');
        this.submitButtonText.classList.remove('hidden');
        this.submitButton.removeAttribute('aria-disabled');
      }
      return !invalid;
    }

    async recheckCartLimitError() {
      if (this.cartLimitCheckPending) {
        this.cartLimitCheckQueued = true;
        return;
      }
      this.cartLimitCheckPending = true;

      try {
        const response = await fetch(`${routes.cart_url}.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) return;

        const cart = await response.json();
        const variantId = String(this.variantIdInput.value);
        const cartQuantity = cart.items
          .filter((item) => String(item.variant_id) === variantId)
          .reduce((sum, item) => sum + item.quantity, 0);
        const input = this.closest('product-info')?.querySelector('.quantity__input');
        if (!input || String(this.variantIdInput.value) !== variantId) return;

        input.dataset.cartQuantity = String(cartQuantity);
        this.validateStockQuantity(false);
      } catch (error) {
        console.error('Sepet stok durumu kontrol edilemedi:', error);
      } finally {
        this.cartLimitCheckPending = false;
        if (this.cartLimitCheckQueued) {
          this.cartLimitCheckQueued = false;
          this.recheckCartLimitError();
        }
      }
    }

    onSubmitHandler(evt) {

        evt.preventDefault();

        // Anahtar ayrı krem işlemini yürütüyorsa ana ürünü yeniden ekleme.
        if (this.careAddPending || this.careSelectionSeparate) return;
        if (!this.validateStockQuantity()) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.error = false;

        this.submitButton.setAttribute('aria-disabled', true);

        this.submitButton.classList.add('loading');

        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {

          formData.append(

            'sections',

            this.cart.getSectionsToRender().map((section) => section.id)

          );

          formData.append('sections_url', window.location.pathname);

          this.cart.setActiveElement(document.activeElement);

        }

        const variantId = formData.get('id');

        const quantity = parseInt(formData.get('quantity'), 10) || 1;

        // Bakım önerisi anahtarını yalnızca ilgili ürün alanında ara.

        const productInfo = this.closest('product-info');

        const careCheckbox = productInfo

          ? productInfo.querySelector('.kavedan-care__checkbox')

          : null;

        const careVariantId = careCheckbox?.checked

          ? careCheckbox.dataset.careVariantId

          : null;

        const addCareProduct =

          careCheckbox?.checked &&

          careVariantId &&

          /^\d+$/.test(careVariantId) &&

          careVariantId !== String(variantId);

        if (addCareProduct) {

          // Ana ürünün özelliklerini ve satış planını koru.

          const mainItem = {

            id: Number(variantId),

            quantity: quantity

          };

          const properties = {};

          for (const [key, value] of formData.entries()) {

            const match = key.match(/^properties\[(.+)\]$/);

            if (match && value !== '') {

              properties[match[1]] = value;

            }

          }

          if (Object.keys(properties).length) {

            mainItem.properties = properties;

          }

          const sellingPlan = formData.get('selling_plan');

          if (sellingPlan) {

            mainItem.selling_plan = Number(sellingPlan);

          }

          const items = [

            mainItem,

            {

              id: Number(careVariantId),

              quantity: 1

            }

          ];

          const payload = { items };

          if (this.cart) {

            payload.sections = this.cart

              .getSectionsToRender()

              .map((section) => section.id);

            payload.sections_url = window.location.pathname;

          }

          config.headers['Content-Type'] = 'application/json';

          config.body = JSON.stringify(payload);

        } else {

          // Anahtar kapalı: Shopify'ın orijinal işlemi.

          config.body = formData;

        }

        const linesUpdateDeferred = this.createCartLinesUpdateEvent(

          variantId,

          quantity,

          addCareProduct ? careVariantId : null

        );

        fetch(`${routes.cart_add_url}`, config)

          .then((response) => response.json())

          .then((response) => {

            if (response.status) {
            this.cartLimitError = true;

              publish(PUB_SUB_EVENTS.cartError, {

                source: 'product-form',

                productVariantId: variantId,

                errors: response.errors || response.description,

                message: response.message,

              });

              this.handleErrorMessage(response.description);

              this.dispatchCartErrorEvent(

                response.description || response.message,

                'INVALID'

              );

              linesUpdateDeferred?.reject(

                new Error(response.description || response.message)

              );

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) {

                this.error = true;

                return;

              }

              // Stok uyarısı hata alanında gösterilir; düğmenin görünümü korunur.
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButtonText.classList.remove('hidden');
              soldOutMessage.classList.add('hidden');

              this.error = true;

              return;

            }

            if (!this.cart) {

              this.resolveCartLinesUpdate(linesUpdateDeferred);

              window.location = window.routes.cart_url;

              return;

            }

            // Çoklu ürün yanıtında ana ürün kimliğini koru.

            // Craft sepet çekmecesi bu alanı kullanıyor.

            if (addCareProduct && Array.isArray(response.items)) {

              response.id = Number(variantId);

            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker(

              'add:wait-for-subscribers'

            );

            if (!this.error) {

              publish(PUB_SUB_EVENTS.cartUpdate, {

                source: 'product-form',

                productVariantId: variantId,

                cartData: response,

              }).then(() => {

                CartPerformance.measureFromMarker(

                  'add:wait-for-subscribers',

                  startMarker

                );

              });

            }

            this.error = false;
            this.cartLimitError = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {

              document.body.addEventListener(

                'modalClosed',

                () => {

                  setTimeout(() => {

                    CartPerformance.measure(

                      'add:paint-updated-sections',

                      () => {

                        this.cart.renderContents(response);

                      }

                    );

                  });

                },

                { once: true }

              );

              quickAddModal.hide(true);

            } else {

              CartPerformance.measure(

                'add:paint-updated-sections',

                () => {

                  this.cart.renderContents(response);

                }

              );

            }

          })

          .catch((e) => {

            console.error(e);

            this.handleErrorMessage(e.message || 'Network error');

            this.dispatchCartErrorEvent(

              e.message || 'Network error',

              'SERVICE_UNAVAILABLE'

            );

            linesUpdateDeferred?.reject(e);

            this.error = true;

          })

          .finally(() => {

            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {

              this.cart.classList.remove('is-empty');

            }

            // Başarısız istekte de düğme uyarıyla birlikte kullanılabilir kalsın.
            if (!this.submitButton.disabled) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);

          });

      }

      handleErrorMessage(errorMessage = false) {

        if (this.hideErrors) return;

        this.errorMessageWrapper =

          this.errorMessageWrapper ||

          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =

          this.errorMessage ||

          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.classList.toggle('kavedan-stock-notice',
          typeof errorMessage === 'string' && errorMessage.startsWith('Bu üründen '));

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {

          this.errorMessage.textContent = errorMessage;

        }

      }

      toggleSubmitButton(disable = true, text) {

        if (disable) {

          this.submitButton.setAttribute('disabled', 'disabled');

          if (text) this.submitButtonText.textContent = text;

        } else {

          this.submitButton.removeAttribute('disabled');

          this.submitButtonText.textContent = window.variantStrings.addToCart;

        }

      }

      createCartLinesUpdateEvent(variantId, quantity, careVariantId = null) {

        const { CartLinesUpdateEvent } = window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();

        const lines = [

          {

            merchandiseId: variantId,

            quantity

          }

        ];

        if (careVariantId) {

          lines.push({

            merchandiseId: careVariantId,

            quantity: 1

          });

        }

        this.dispatchEvent(

          new CartLinesUpdateEvent({

            action: 'add',

            context: 'product',

            lines,

            promise: deferred.promise,

          })

        );

        return deferred;

      }

      resolveCartLinesUpdate(deferred) {

        if (!deferred) return;

        const { CartLinesUpdateEvent } = window.StandardEvents || {};

        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise =

          typeof CartItems !== 'undefined'

            ? CartItems.fetchCartData()

            : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise

          .then((cart) => {

            if (!cart?.currency) {

              return deferred.reject(

                new Error('Missing currency in cart response')

              );

            }

            deferred.resolve({

              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart)

            });

          })

          .catch((e) => deferred.reject(e));

      }

      dispatchCartErrorEvent(message, code) {

        const { CartErrorEvent } = window.StandardEvents || {};

        if (!CartErrorEvent) return;

        this.dispatchEvent(

          new CartErrorEvent({

            error: message,

            code

          })

        );

      }

      get variantIdInput() {

        return this.form.querySelector('[name=id]');

      }

    }

  );

}
